import { ActionTypes } from "@/App/constants/actionTypes";
import { Action } from "@/App/actions";
import { PlanTypes } from "@/types";

export interface PlanGetState {
  loading: boolean;
  plan: {
    details: PlanTypes.Plan;
  };
}

const DEFAULT_PLAN_GET_STATE: PlanGetState = {
  loading: false,
  plan: {
    details: {
      address_line_1: "",
      address_line_2: "",
      bin_number: "",
      city: "",
      client_id: "",
      group_number: "",
      id: null,
      name: "",
      processor_control_number: "",
      state: "",
      zip_code: "",
      claim_payment_cycle: "",
      effective_date: "",
      created_at: "",
      updated_at: "",
      status: null,
      groups_status: null,
      eligibility_status: null,
      member_documents_status: null,
      absence_method: "",
      absence_boundary: "",
      absence_method_terminate_date_option: "",
      absence_method_group: "",
      absence_method_group_terminate_date_option: "",
      eligibility_reject_failure_threshold: null,
      eligibility_change_failure_threshold: null,
      accumulation_load_failure_threshold: null,
      external_member_id_pattern: "",
      external_member_id_length: null,
      person_code_length: null,
      customer_service_phone_number: "",
      help_desk_phone: "",
      plan_additional_covered_type: "",
      plan_additional_covered_standard_deductible: "",
      plan_additional_covered_standard_plan_max: "",
      plan_additional_covered_standard_category_plan_max: "",
      plan_additional_covered_percentage_amount: null,
      plan_additional_covered_dollar_amount: null,
      pricing_status: null,
      pharmacy_service_fee_enabled: false,
      strategic_partner_fee: null,
    },
  },
};

export default (state: PlanGetState = DEFAULT_PLAN_GET_STATE, action: Action): PlanGetState => {
  if (action.type === ActionTypes.GET_PLAN) {
    return {
      ...DEFAULT_PLAN_GET_STATE,
      loading: true,
    };
  } else if (action.type === ActionTypes.GET_PLAN_FAILURE) {
    return {
      ...state,
      loading: false,
    };
  } else if (action.type === ActionTypes.GET_PLAN_SUCCESS) {
    return {
      ...state,
      loading: false,
      plan: {
        ...state.plan,
        details: action.payload,
      },
    };
  } else {
    return state;
  }
};
